module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.arrData || _vm.arrData.length === 0
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "py-3": ""
    }
  }, [_vm._v("\n            Для импорта данных, выберите файл (xlsx, csv), содержащий обязательные  колонки: "), _c('b', [_vm._v("\n            инн физ. лица, фамилия, имя, отчество")]), _vm._v(" и дополнительные колонки: "), _c('b', [_vm._v(" пол, дата рождения, снилс, номер паспорта РФ, инн компании, должность, телефон, email, адрес.")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm6": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(item.name.slice(0, 30)) + "\n              ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pickFile.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n              Выберите файл для импорта\n              ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat(),
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n            Уточните соответствие атрибутов записи о физ.лице и колонок в загружаемом файле\n          ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('b', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Атрибут")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Название колонки")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Пример значения")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.fields), function(item) {
    return [_c('v-layout', {
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "sm3": ""
      }
    }, [_c('span', [_vm._v(_vm._s(item.label))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('v-select', {
      attrs: {
        "hide-details": "",
        "items": _vm.getNewFields(),
        "item-value": "value",
        "item-text": "text"
      },
      model: {
        value: (item.number),
        callback: function($$v) {
          _vm.$set(item, "number", $$v)
        },
        expression: "item.number"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.getValue(item)))])])], 1)]
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n          При импорте данных происходит проверка формата, если данные не удовлетворяют формату, то они не записываются в систему. "), _c('br'), _vm._v("Для более точной настройки укажите форматы следующих данных:\n        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Муж/Жен",
      "items": [{
          value: 'MF',
          text: 'Муж.(M)/Жен.(F)'
        },
        {
          value: '01',
          text: 'Муж.(0)/Жен.(1)'
        },
        {
          value: '12',
          text: 'Муж.(1)/Жен.(2)'
        }
      ]
    },
    model: {
      value: (_vm.genderFormat),
      callback: function($$v) {
        _vm.genderFormat = $$v
      },
      expression: "genderFormat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Формат дат",
      "items": [{
          value: 'YYYY-MM-DD',
          text: 'гггг-мм-дд'
        },
        {
          value: 'DD/MM/YYYY',
          text: 'дд/мм/гггг'
        },
        {
          value: 'DD.MM.YYYY',
          text: 'дд.мм.гггг'
        }
      ]
    },
    model: {
      value: (_vm.dateFormat),
      callback: function($$v) {
        _vm.dateFormat = $$v
      },
      expression: "dateFormat"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a52594c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/PeopleLoader.vue
// module id = 905
// module chunks = 1